// HY Review carousel: native scroll-snap track; this only wires arrows, dots and start/end state.
if (!customElements.get('hy-review-carousel')) {
  customElements.define('hy-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hy-review-carousel__track');
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      this.dots = Array.from(this.querySelectorAll('.hy-review-carousel__dot'));
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index() - 1));
      if (next) next.addEventListener('click', () => this.go(this.index() + 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
      const schedule = () => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(() => this.update()); };
      this.track.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      this.update();
    }
    step() {
      const s = this.slides;
      return (s.length > 1 ? s[1].offsetLeft - s[0].offsetLeft : this.track.clientWidth) || 1;
    }
    maxIndex() {
      return Math.max(0, Math.round((this.track.scrollWidth - this.track.clientWidth) / this.step()));
    }
    index() {
      return Math.min(this.maxIndex(), Math.round(this.track.scrollLeft / this.step()));
    }
    go(i) {
      const target = Math.max(0, Math.min(i, this.maxIndex()));
      this.track.scrollTo({ left: target * this.step(), behavior: 'smooth' });
    }
    update() {
      const i = this.index();
      const max = this.maxIndex();
      this.classList.toggle('is-start', i <= 0);
      this.classList.toggle('is-end', i >= max);
      this.dots.forEach((dot, n) => {
        dot.hidden = n > max;
        dot.classList.toggle('is-active', n === i);
        if (n === i) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
    }
  });
}
